(ns manage.resource.feed-imports
  (:require [common.url-template :as url-tpl]
            [mate.re-frame :as mr]
            [re-frame.core :as rf]))

(rf/reg-event-fx :resource.feed-importers/get-one
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ id]]
    {:db (assoc db :resource.feed-importers/one {:state :pending :value []})
     :http
     {:method :get
      :uri (url-tpl/render :api/feed-importer (assoc url-context :feed-importer-id id))
      :headers {:Authorization (:resource.user/token cofx)}
      :on-success [:resource.feed-importers/get-one-success]
      :on-failure [:resource.feed-importers/get-one-failure]}}))

(rf/reg-event-db :resource.feed-importers/get-one-success
  (fn [db [_ feed]]
    (assoc db :resource.feed-importers/one {:state :success
                                            :value feed})))

(rf/reg-event-db :resource.feed-importers/get-one-failure
  (fn [db _]
    (assoc db :resource.feed-importers/one {:state :failure
                                            :value []})))

(defn http-post-feed [effects url-context params token {:keys [on-success on-failure] :as _callbacks}]
  (-> effects
      (mr/conj-fx [:http {:method :post
                          :uri (url-tpl/render :api/feed-importers url-context)
                          :params params
                          :headers {:Authorization token}
                          :on-success on-success
                          :on-failure on-failure}])))

(defn http-patch-feed [effects url-context params token {:keys [on-success on-failure] :as _callbacks}]
  (-> effects
      (mr/conj-fx [:http {:method :patch
                          :uri (url-tpl/render :api/feed-importer (assoc url-context :feed-importer-id (:id params)))
                          :params params
                          :headers {:Authorization token}
                          :on-success on-success
                          :on-failure on-failure}])))

(defn on-feed-importers-one-success [effects feed]
  (-> effects
      (mr/update-db assoc :resource.feed-importers/one {:state :success
                                                        :value feed})))

(rf/reg-event-fx :resource.feed-importers/delete
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ id]]
    {:http
     {:method :delete
      :uri (url-tpl/render :api/feed-importer (assoc url-context :feed-importer-id id))
      :headers {:Authorization (:resource.user/token cofx)}
      :on-success [:resource.feed-importers/delete-success]
      :on-failure [:resource.feed-importers/delete-failure]}}))

(rf/reg-event-db :resource.feed-importers/delete-success
  (fn [db] db))

(rf/reg-event-db :resource.feed-importers/delete-failure
  (fn [db] db))

(rf/reg-event-fx :resource.feed-importers/trigger
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ id trigger-ad-variants]]
    {:http
     {:method :post
      :format :blank
      :response-format :text
      :uri (url-tpl/render :api/feed-importer-trigger (assoc url-context :feed-importer-id id)
                           (when (boolean? trigger-ad-variants)
                             {:trigger-ad-variants trigger-ad-variants}))
      :headers {:Authorization (:resource.user/token cofx)}
      :on-success [:resource.feed-importers/trigger-success id]
      :on-failure [:resource.feed-importers/trigger-failure id]}}))

(rf/reg-event-fx :resource.feed-importers/trigger-success
  (fn [_ [_ feed-id]]
    {:fx [[:invalidate-queries {:queryKey ["latest-feed-import-status-query" feed-id]}]]}))

(rf/reg-event-db :resource.feed-importers/trigger-failure
  (fn [db]
    db))

(rf/reg-sub :resource.feed-importers/all
  (fn [db]
    (:resource.feed-importers/all db)))

(rf/reg-sub :resource.feed-importers/one
  (fn [db]
    (:resource.feed-importers/one db)))

(rf/reg-event-fx :resource.feed-importers/get-fields
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context db] :as cofx} [_ feed-importer-id]]
    {:db (assoc db :resource.feed-importers/fields {:state :pending
                                                    :value nil})
     :http
     {:method :get
      :uri (url-tpl/render :api/feed-importer-fields
                           (merge url-context {:feed-importer-id feed-importer-id}))
      :headers {:Authorization (:resource.user/token cofx)}
      :on-success [:resource.feed-importers/get-fields-success]
      :on-failure [:resource.feed-importers/get-fields-failure]}}))

(rf/reg-event-db :resource.feed-importers/get-fields-success
  (fn [db [_ fields]]
    (assoc db :resource.feed-importers/fields {:state :success
                                               :value fields})))

(rf/reg-event-db :resource.feed-importers/get-fields-failure
  (fn [db [_ response]]
    (cond-> db
      true
      (assoc :resource.feed-importers/fields {:state :failure
                                              :value nil})
      (= "redirected-to-sign-in-page-fetching" (get-in response [:value :error :details :reason]))
      (assoc-in [:page.content-configuration/get-fields-failure-response] response))))

(rf/reg-sub :resource.feed-importers/fields
  (fn [db _]
    (:resource.feed-importers/fields db)))

(rf/reg-sub :page.content-configuration/get-fields-failure-response
  (fn [db _]
    (get-in db [:page.content-configuration/get-fields-failure-response])))

(rf/reg-event-fx :resource.feed-importers/get-content-variant
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context db] :as cofx} [_ id]]
    {:db (assoc db :resource.feed-importers/content-variant {:state :pending
                                                             :value nil})
     :http
     {:method :get
      :uri (url-tpl/render :api/feed-importer-content-variant (assoc url-context :feed-importer-id id))
      :headers {:Authorization (:resource.user/token cofx)}
      :on-success [:resource.feed-importers/get-content-variant-success]
      :on-failure [:resource.feed-importers/get-content-variant-failure]}}))

(rf/reg-event-db :resource.feed-importers/get-content-variant-success
  (fn [db [_ mappings]]
    (assoc db :resource.feed-importers/content-variant {:state :success
                                                        :value mappings})))

(rf/reg-event-db :resource.feed-importers/get-content-variant-failure
  (fn [db]
    (assoc db :resource.feed-importers/content-variant {:state :failure})))

(rf/reg-event-fx :resource.feed-importers/put-content-variant
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ id payload]]
    {:http
     {:method :put
      :params payload
      :uri (url-tpl/render :api/feed-importer-content-variant (assoc url-context :feed-importer-id id))
      :headers {:Authorization (:resource.user/token cofx)}
      :on-success [:resource.feed-importers/put-content-variant-success]
      :on-failure [:resource.feed-importers/put-content-variant-failure]}}))

(rf/reg-event-db :resource.feed-importers/put-content-variant-success
  (fn [db] db))

(rf/reg-event-db :resource.feed-importers/put-content-variant-failure
  (fn [db] db))

(rf/reg-event-fx :resource.feed-importers/get-content-feed
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ id]]
    {:db (assoc db :resource.feed-importers/content-feed {:state :pending
                                                          :value nil})
     :http
     {:method :get
      :uri (url-tpl/render :api/content-build-feed (assoc url-context :feed-importer-id id))
      :headers {:Authorization (:resource.user/token cofx)}
      :on-success [:resource.feed-importers/get-content-feed-success]
      :on-failure [:resource.feed-importers/get-content-feed-failure]}}))

(rf/reg-event-db :resource.feed-importers/get-content-feed-success
  (fn [db [_ response]]
    (assoc db :resource.feed-importers/content-feed {:state :success
                                                     :value (:data response)})))

(rf/reg-event-db :resource.feed-importers/get-content-feed-failure
  (fn [db]
    (assoc db :resource.feed-importers/content-feed {:state :failure
                                                     :value nil})))

(rf/reg-sub :resource.feed-importers/content-feed
  (fn [db]
    (:resource.feed-importers/content-feed db)))

(rf/reg-sub :resource.feed-importers/field-content-mappings
  :<- [:resource.feed-importers/content-feed]
  (fn [content-feed _]
    (get-in content-feed [:value :field-content-mappings])))

(rf/reg-sub :resource.feed-importers/field-content-mappings-configured?
  :<- [:resource.feed-importers/field-content-mappings]
  (fn [field-mappings]
    (every? #(some? (:placeholder %)) field-mappings)))

(rf/reg-sub :resource.feed-importers/field-classes-configured?
  :<- [:resource.feed-imports/field-classes-sorted]
  (fn [field-classes]
    (boolean (seq field-classes))))

(rf/reg-event-fx :resource.feed-importers/update-field-classes
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ id payload allow-owerriding]]
    {:http
     {:method :put
      :params payload
      :uri (url-tpl/render :api/content-build-field-classes
                           (assoc url-context :feed-importer-id id)
                           {:allow-overwriting allow-owerriding})
      :headers {:Authorization (:resource.user/token cofx)}
      :on-success [:resource.feed-importers/update-field-classes-success]
      :on-failure [:resource.feed-importers/update-field-classes-failure]}}))

(rf/reg-event-db :resource.feed-importers/update-field-classes-success
  (fn [db] db))

(rf/reg-event-db :resource.feed-importers/update-field-classes-failure
  (fn [db] db))

(rf/reg-event-fx :resource.feed-importers/update-field-content-mappings
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ id payload allow-owerriding]]
    {:http
     {:method :put
      :params payload
      :uri (url-tpl/render :api/content-build-field-content-mappings
                           (assoc url-context :feed-importer-id id)
                           {:allow-overwriting allow-owerriding})
      :headers {:Authorization (:resource.user/token cofx)}
      :on-success [:resource.feed-importers/update-field-content-mappings-success]
      :on-failure [:resource.feed-importers/update-field-content-mappings-failure]}}))

(rf/reg-event-db :resource.feed-importers/update-field-content-mappings-success
  (fn [db] db))

(rf/reg-event-db :resource.feed-importers/update-field-content-mappings-failure
  (fn [db] db))

(rf/reg-event-fx :resource.feed-importers/update-field-formats
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ id payload]]
    {:http
     {:method :put
      :params payload
      :uri (url-tpl/render :api/content-build-field-formats (assoc url-context :feed-importer-id id))
      :headers {:Authorization (:resource.user/token cofx)}
      :on-success [:resource.feed-importers/update-field-formats-success]
      :on-failure [:resource.feed-importers/update-field-formats-failure]}}))

(rf/reg-event-db :resource.feed-importers/update-field-formats-success
  (fn [db] db))

(rf/reg-event-db :resource.feed-importers/update-field-formats-failure
  (fn [db] db))

(rf/reg-sub :resource.feed-imports/field-classes
  (fn [db _]
    (get-in db [:resource.feed-importers/content-feed :value :field-classes])))

(rf/reg-sub :resource.feed-importers/fields-value
  (fn [db _]
    (get-in db [:resource.feed-importers/fields :value])))

(rf/reg-sub :resource.feed-imports/field-classes-sorted
  :<- [:resource.feed-imports/field-classes]
  :<- [:resource.feed-importers/fields-value]
  (fn [[field-classes fields] _]
    ;; there is cases when fields-value not accessible but it is still required to render content-variants
    ;; for that specific edge case field-classes used in unsorted way
    (if (and field-classes fields)
      (vec (sort-by #(.indexOf fields (:name %)) field-classes))
      field-classes)))
